/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconClients = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 26 22"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 22px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M16 16H3.933C2.313 16 1 14.567 1 12.8V4.2C1 2.433 2.313 1 3.933 1h14.134C19.687 1 21 2.433 21 4.2V6M11.002 16v5" />
        <path d="M19.556 8h3.888C24.304 8 25 8.776 25 9.733v9.534c0 .957-.696 1.733-1.556 1.733h-3.888c-.86 0-1.556-.776-1.556-1.733V9.733C18 8.776 18.696 8 19.556 8zM18 18h7M7 21h8" />
      </g>
    </svg>
  ),
);
